export const LANDING_PAGE_WIDTH_CONSTRAINTS = `max-w-[1408px] px-5 lg:px-12 mx-auto`

// Standard vertical rhythm between landing sections: 80px.
export const LANDING_PAGE_SECTION_PADDING = `py-10`

/** Single source for examples section header (used in default sections slot + examples fallback). */
export const LANDING_EXAMPLES_HEADING = {
    title: 'Launch-Ready Content & Ads',
    subtitle: 'Amazing videos or statics by chatting with your agent, plus ready-to-run video templates',
} as const
